import { render } from "./ResizebleScreen.vue?vue&type=template&id=5c6299af"
import script from "./ResizebleScreen.vue?vue&type=script&lang=js"
export * from "./ResizebleScreen.vue?vue&type=script&lang=js"

import exportComponent from "/builds/prohemo/education/mental-maps/metal-maps-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__